"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../core/table"));
var _helpButton = _interopRequireDefault(require("../../core/help-button"));
var _alert = _interopRequireDefault(require("../../core/alert"));
var _container = _interopRequireDefault(require("../../core/container"));
var _button = _interopRequireDefault(require("../../core/button"));
var _defaultRacesHelp = _interopRequireDefault(require("./default-races-help"));
var _addDefaultRace = _interopRequireDefault(require("./add-default-race"));
var _defaultRaceRow = _interopRequireDefault(require("./default-race-row"));
var _defaultRaceEligibilities = _interopRequireDefault(require("./default-race-eligibilities"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_defaultRacesHelp.default, null));
var _ref2 = /*#__PURE__*/_react.default.createElement(_addDefaultRace.default, null);
var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref4 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, /*#__PURE__*/_react.default.createElement("p", null, "Changes to default races and eligibilities will not change any Competitions where the races have already been created, with the exception of:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Simply Slalom Sheet - picked up during Simply Slalom export"), /*#__PURE__*/_react.default.createElement("li", null, "Siwidata Code - picked up during Timing Team export"), /*#__PURE__*/_react.default.createElement("li", null, "Show Paddler Division - picked up during card printing")), /*#__PURE__*/_react.default.createElement("p", null, "Runs for expired default races should be manually removed from the default start list."));
var _ref5 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref6 = /*#__PURE__*/_react.default.createElement("th", null, "Division");
var _ref7 = /*#__PURE__*/_react.default.createElement("th", null, " Event");
var _ref8 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, " Multi-Class");
var _ref9 = /*#__PURE__*/_react.default.createElement("th", null, " Name");
var _ref10 = /*#__PURE__*/_react.default.createElement("th", null, " Simply Slalom Sheet");
var _ref11 = /*#__PURE__*/_react.default.createElement("th", null, " Siwidata Code");
var _ref12 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, " Show Paddler Ranking");
var _ref13 = /*#__PURE__*/_react.default.createElement("td", null);
class DefaultRaces extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      showEligibilities: {}
    });
    _defineProperty(this, "_getAllEligibilitiesShown", () => {
      return this.props.defaultRaces.every(race => this.state.showEligibilities[race.id]);
    });
    _defineProperty(this, "_toggleShowAllEligibilities", () => {
      const newShowEligibilities = {};
      const showAllEligibilities = !this._getAllEligibilitiesShown();
      this.props.defaultRaces.forEach(race => {
        newShowEligibilities[race.id] = showAllEligibilities;
      });
      this.setState({
        showEligibilities: newShowEligibilities
      });
    });
    _defineProperty(this, "_toggleEligibilities", raceID => {
      this.setState({
        showEligibilities: {
          ...this.state.showEligibilities,
          [raceID]: !this.state.showEligibilities[raceID]
        }
      });
    });
    _defineProperty(this, "_onChange", (id, value, name) => {
      this.props.onUpdate(id, name, value);
    });
  }
  render() {
    const defaultRaceSets = [{
      setName: 'Current Default Races',
      defaultRaces: this.props.defaultRaces.filter(race => !race.isExpired)
    }, {
      setName: 'Expired Default Races',
      defaultRaces: this.props.defaultRaces.filter(race => race.isExpired)
    }];
    return /*#__PURE__*/_react.default.createElement(_container.default, null, _ref, _ref2, _ref3, _ref4, defaultRaceSets.map(raceSet => /*#__PURE__*/_react.default.createElement("div", {
      key: raceSet.setName
    }, _ref5, /*#__PURE__*/_react.default.createElement("h5", null, raceSet.setName), /*#__PURE__*/_react.default.createElement("div", null, !raceSet.defaultRaces.length ? /*#__PURE__*/_react.default.createElement("p", null, raceSet.setName === 'Expired Default Races' ? 'No default races have been expired' : 'No default races') : /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleShowAllEligibilities
    }, this._getAllEligibilitiesShown() ? 'Hide Eligibilities' : 'All Eligibilities')), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12)), /*#__PURE__*/_react.default.createElement("tbody", null, raceSet.defaultRaces.map(race => [/*#__PURE__*/_react.default.createElement(_defaultRaceRow.default, {
      key: race.id,
      race: race,
      toggleEligibilities: this._toggleEligibilities.bind(this, race.id),
      showEligibilities: this.state.showEligibilities[race.id]
    }), !this.state.showEligibilities[race.id] ? null : /*#__PURE__*/_react.default.createElement("tr", {
      key: race.id + 'E'
    }, _ref13, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: 5
    }, /*#__PURE__*/_react.default.createElement(_defaultRaceEligibilities.default, {
      canEdit: !race.isExpired,
      defaultRaceID: race.id,
      defaultRaceEligibilities: race.defaultRaceEligibilities
    })))])))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref14 = {
  defaultRaces: _mergeBqlQueries(_mergeBqlQueries({}, _defaultRaceEligibilities.default.partialQueries.DefaultRace), _defaultRaceRow.default.partialQueries.DefaultRace)
};
var _default = exports.default = (0, _reactBicycle.connect)(DefaultRaces, props => _ref14, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('DefaultRace.set', {
      id,
      field,
      value
    });
  }
}));